import type { CustomStoreImplementationOptions, KaElementMap, MergeCustomStore, StoreIdentifier } from 'kapix-components-vue3'
import { defineStore } from 'pinia'
import { initAliveStoreIds, kapixContext, openUrl, remove, scrollInfo } from 'kapix-components-vue3'
import parrainageStoreCustom from './store.custom'
import { $translate } from '~/modules/i18n'

const storeName = 'parrainage'
const customImplement: CustomStoreImplementationOptions = parrainageStoreCustom.options
const aliveStoreIds = initAliveStoreIds()

function parrainageFactory (storeId?: Nullable<StoreIdentifier>) {
  return defineStore(storeId == null ? storeName : `${storeName}/${storeId}`, {
    state: () => {
      return {
        $aliveStoreIds: aliveStoreIds,
        $subStoreIds: 1,
        $storeId: storeId,
        $emit: (() => {}) as (propName: any, value: any) => void,
        $elements: {} as KaElementMap,
        $router: kapixContext.isClient ? kapixContext.$router : undefined,
        $route: kapixContext.isClient ? kapixContext.$route : undefined,
        // Page info,
        $title: $translate('parrainage.title', 'Parrainage'),
        $description: $translate('parrainage.description', ''),
        $publishedTime: new Date('2023-02-13T07:42:17.523Z'),
        $modifiedTime: new Date('2023-05-24T08:16:28.929Z'),
        // Constants,
        $constants: {},
        // Data,
        $info: { parrainage: scrollInfo() },
        ...(customImplement.state && customImplement.state())
      }
    },
    getters: {
      ...customImplement.getters
    },
    actions: {
      /* @ts-ignore: to allow override in your custom file */
      commentCaMarcheClick () {
        // Page not found, has it been deleted ?
      },
      /* @ts-ignore: to allow override in your custom file */
      etapesClick () {
        // Page not found, has it been deleted ?
      },
      /* @ts-ignore: to allow override in your custom file */
      prendreRendezVousClick () {
        openUrl('https://meetings.hubspot.com/christophe-pramil', '_self')
      },
      /* @ts-ignore: to allow override in your custom file */
      getStoreInstance (storeId?: Nullable<StoreIdentifier>) {
        return storeId != null ? getStoreInstance(storeId) : this
      },
      /* @ts-ignore: to allow override in your custom file */
      getStoreInstances () {
        return aliveStoreIds.map(storeId => this.getStoreInstance(storeId))
      },
      /* @ts-ignore: to allow override in your custom file */
      newStoreInstance (storeId?: Nullable<StoreIdentifier>) {
        const newStoreId = storeId || this.$subStoreIds++
        if (aliveStoreIds.includes(newStoreId)) {
          throw new Error(`Store with id ${storeId} already exists`)
        }
        aliveStoreIds.push(newStoreId)
        return getStoreInstance(newStoreId)
      },
      ...customImplement.actions,
      /* @ts-ignore: to allow override in your custom file */
      beforeMount () {
        customImplement.actions?.beforeMount?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      mounted () {
        customImplement.actions?.mounted?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      async serverPrefetch () {
        await customImplement.actions?.serverPrefetch?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      beforeUnmount () {
        customImplement.actions?.beforeUnmount?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      unmounted () {
        if (this.$storeId != null) {
          this.$dispose()
          remove(aliveStoreIds, this.$storeId)
        }
        customImplement.actions?.unmounted?.call(this)
      }
    }
  })
}

function getStoreInstance (storeId?: Nullable<StoreIdentifier>) {
  return parrainageFactory(storeId)()
}

export const parrainageRaw = parrainageFactory()
export const parrainage = () => parrainageRaw() as MergeCustomStore<typeof parrainageStoreCustom.instance>
